import { Component, ViewChild } from '@angular/core';
import { ShowComponent } from '../../common/component/show.component';

import { BankCardOwnersComponent } from '../bank-card-owners/bank-card-owners.component';
import { BankCardSetComponent } from '../bank-card-set/bank-card-set.component';
import { BankArchiveStatus, BankCard, BankDepartments, BankOwnersTypes, BankOwnersTypesOther } from '../bank.model';
import { Users } from '@/users/users.model';
import { Driver } from '@/drivers/driver.model';
import { Vehicle } from '@/vehicles/vehicle.model';

@Component({
	selector: 'app-bank-card',
	templateUrl: './bank-card.component.html',
	styleUrls: ['./bank-card.component.css'],
})
export class BankCardComponent extends ShowComponent {
	protected itemsBeforeDataLoad = 6;
	protected parentComponent = 'bankCards';
	data: BankCard = {
		id: null,
		number: null,
		comments: null,
		status: BankArchiveStatus.ACTIVE,
	};
	ownersTypes: BankOwnersTypes[] = [];
	users: Users[] = [];
	drivers: Driver[] = [];
	vehicles: Vehicle[] = [];
	departments: BankDepartments[] = [];
	ownersOther: BankOwnersTypesOther[] = [];
	@ViewChild(BankCardOwnersComponent) bankCardsOwners: BankCardOwnersComponent;

	protected loadBefore() {
		this.api.get('/bankOwnersTypes', (result, error) => {
			this.ownersTypes = result.data;
			this.loadData();
		});
		this.api.get('/users', (result, error) => {
			this.users = result.data;
			this.loadData();
		});
		this.api.get('/drivers', (result, error) => {
			this.drivers = result.data;
			this.loadData();
		});
		this.api.get('/vehicles', (result, error) => {
			this.vehicles = result.data;
			this.loadData();
		});
		this.api.get('/departments', (result, error) => {
			this.departments = result.data;
			this.loadData();
		});
		this.api.get('/bankOwnersTypesOther', (result, error) => {
			this.ownersOther = result.data;
			this.loadData();
		});
	}

	edit() {
		new BankCardSetComponent(this.api, this.infobox, this.router).dialogOpen();
	}
}
